import apiFetch from '@wordpress/api-fetch';
import {addQueryArgs, buildQueryString} from '@wordpress/url';

interface immoParamsInterface {
	fields?: [];
	objekt_id?: [];
}

interface searchParamsInterface {
	objektart?: string;
	marktart?: string;
	ort?: string;
	script?: string;
	order?: string;
	orderby?: string;
}

const api = {
	immobilien: {
		getItems: ( params: immoParamsInterface = {} ): Promise< any[] > => {
			return apiFetch( {
				path: addQueryArgs( `/wpi/v2/immobilien`, params ),
				method: 'GET',
			} );
		},
		getItem: (
			id: number,
			params: immoParamsInterface
		): Promise< any[] > => {
			return apiFetch( {
				path: addQueryArgs( `/wpi/v2/immobilien/${ id }`, params ),
				method: 'GET',
			} );
		},
	},
	search: {
		selectOptions: (): Promise< any > => {
			return apiFetch( {
				path: `immobilien/v1/selectOptions`,
				method: 'GET',
			} );
		},
		searchCount: ( params: searchParamsInterface ) => {
			return apiFetch( {
				path: 'immobilien/v1/advancedSearchCount',
				method: 'POST',
				data: params,
			} );
		},
		ajaxSearch: ( params: searchParamsInterface ) => {
			return apiFetch( {
				path: `immobilien/v1/ajaxSearch?${ buildQueryString(
					params
				) }`,
			} );
		},
	},
};

export { api, immoParamsInterface, searchParamsInterface };
